import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { KontniPlanView } from './kontni-plan-view';
import { KontniPlan } from './kontni-plan';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-kontni-plan',
  templateUrl: './kontni-plan.component.html'
})
export class KontniPlanComponent extends BaseModalContainer<KontniPlan> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KontniPlan>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }


  ngOnInit() {
  }

}
